import React, { useEffect, useRef, useState } from "react";
import downIcon from "../../../asset/images/download-blue-arrow.svg";
import filter from "../../../asset/images/preference-horizontal.svg";
import totalReqIcon from "../../../asset/images/fileUpload.svg";
import pendingIcon from "../../../asset/images/timePending.svg";
import approvedIcon from "../../../asset/images/approvedConf.svg";
import draftIcon from "../../../asset/images/edit-withfile.svg";
import rejectedIcon from "../../../asset/images/crossIcon.svg";
import sendBackIcon from "../../../asset/images/sentback-pending.svg";
import { Modal } from "react-bootstrap";
import { Dealer_Mapping } from "../../../Configuration/API_URL";
import infoIcon from "../../../asset/images/info-circle.svg";
import { batchIdFormatter, batchIdPaste, decryptData, formatDate, noDataFound, toSentenceCase } from "../../../CommonMethhods/CommonMethods";
import { toast } from "react-toastify";
import axiosInstance from "../../../CommonMethhods/axiosInstance";
import { useDebounce } from "../../../Components/useDebounce";
import moment from "moment";
import Loader from "../../../Components/Common/Loader";
import SmallLoader from "../../../Components/Common/smallLoader";
import CustomTradeDate from "../../../CommonMethhods/CustomDate";
import { useNavigate } from "react-router-dom";

// Treats "sendback", "Send Back" and "send_back" as the same status.
const normalizeStatus = (status = "") =>
  (status || "").toLowerCase().replace(/[\s_-]/g, "");

function MyRequests({ setActiveTab, setViewRequest, isDraftTab = false }) {
  const [search, setSearch] = useState("");
  const [filterModal, setFilterModal] = useState(false);
  const [typeFilter, setTypeFilter] = useState("all");
  const [statusFilter, setStatusFilter] = useState(isDraftTab ? "draft" : "all");
  const [cardCounts, setCardCounts] = useState({
    total: 0,
    pending: 0,
    approved: 0,
    draft: 0,
    sendback: 0,
    rejected: 0,
  });
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [loader, setLoader] = useState(false);
  const [historyData, setHistoryData] = useState([]);
  const [downloadLoader, setDownloadLoader] = useState(false);
  const resetBtnRef = useRef(null);
  const applyBtnRef = useRef(null);
  const headerRefs = useRef([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  // Category / Reason for rows the grid endpoint sent without them (it only
  // fills them for single-request batches, so drafts and bulk batches arrive
  // blank). Fetched from the batch details on demand, keyed by batchId.
  const [batchInfo, setBatchInfo] = useState({});
  const requestedBatches = useRef(new Set());

  const debouncedValue = useDebounce(search, 1000);
  const navigate = useNavigate();

  useEffect(() => {
    getRequestHistory(
      "grid",
      debouncedValue,
      fromDate,
      toDate,
      statusFilter,
      typeFilter
    );
  }, [debouncedValue]);

  useEffect(() => {
    setPage(1);
  }, [historyData]);

  useEffect(() => {
    if (!isDraftTab) {
      getCardCounts();
    }
  }, []);

  const getCardCounts = async () => {
    try {
      const queryParams = new URLSearchParams({
        format: "grid",
        status: "all",
        type: "all",
        fromDate: "",
        toDate: "",
        batchIdRef: "",
      });
      const response = await axiosInstance.get(
        `${Dealer_Mapping.validationRowPreview}?${queryParams}`,
      );
      const decrypted = JSON.parse(decryptData(response?.data));

      if (decrypted?.status === 0) {
        const list = decrypted?.data || [];
        const counts = { total: list.length, pending: 0, approved: 0, draft: 0, sendback: 0, rejected: 0 };

        list.forEach((item) => {
          const status = normalizeStatus(item?.status);
          // "partial" is the same state as "pending", so both feed the same card.
          if (status === "pending" || status === "partial") counts.pending += 1;
          else if (status === "approved") counts.approved += 1;
          else if (status === "draft") counts.draft += 1;
          else if (status === "sendback") counts.sendback += 1;
          else if (status === "rejected") counts.rejected += 1;
        });

        setCardCounts(counts);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleCardFilter = (status) => {
    setStatusFilter(status);
    getRequestHistory("grid", search, fromDate, toDate, status, typeFilter);
  };

  const showFilterModal = () => {
    setFilterModal(true);
  };

  // Request details live on their own route so the page survives a refresh
  // or a directly opened URL - the row is passed along only to avoid a flash
  // while the details page re-fetches it.
  const handleViewButton = (row) => {
    if (!row?.batchId) return;

    navigate(`/dealer-mapping/request/${row.batchId}`, {
      state: { request: row },
    });
  };

  const getRequestHistory = async (
    format = "grid",
    searchText = "",
    from = fromDate,
    to = toDate,
    status = statusFilter,
    type = typeFilter
  ) => {

    if (format === "grid") {
      setLoader(true);
    } else {
      setDownloadLoader(true);
    }
    console.log(type);


    try {
      const queryParams = new URLSearchParams({
        format,
        status: status?.toLowerCase() === "all" ? "all" : status.toLowerCase(),
        type: type.toLowerCase() || "all",
        fromDate: from
          ? moment(from, "DD-MM-YYYY").format("YYYY-MM-DD")
          : "",
        toDate: to
          ? moment(to, "DD-MM-YYYY").format("YYYY-MM-DD")
          : "",
        batchIdRef: searchText,
      });
      const response = await axiosInstance.get(
        `${Dealer_Mapping.validationRowPreview}?${queryParams}`,
      );

      const decrypted = JSON.parse(decryptData(response?.data));

      if (decrypted?.status === 0) {
        if (format === "grid") {
          setHistoryData(decrypted?.data);
        } else {
          toast.success(decrypted?.message)
          window.open(decrypted?.data?.url, "_self", "noopener,noreferrer");
        }

      } else {
        setHistoryData([]);
        toast.error(decrypted?.message);
      }
    } catch (error) {
      const decryptedError = JSON.parse(
        decryptData(error?.response?.data)
      );
      toast.error(decryptedError?.message);
    } finally {
      if (format === "grid") {
        setLoader(false);
      } else {
        setDownloadLoader(false);
      }
    }
  };

  const currentDate = new Date();
  const yyyy = currentDate.getFullYear();
  let mm = currentDate.getMonth() + 1;
  let dd = currentDate.getDate();
  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;
  const FormatedDate = dd + "/" + mm + "/" + yyyy;
  const DateReverse = FormatedDate.split("/").reverse().join("-");

  const handleResetFilter = () => {
    setFromDate("");
    setToDate("");
    setTypeFilter("all");

    getRequestHistory(
      "grid",
      search,
      "",
      "",
      statusFilter,
      "all"
    );
  };

  const handleFilterKeyDown = (e) => {
    if (e.key !== "Enter") return;
    if (
      e.target instanceof HTMLButtonElement
    ) {
      return;
    }

    e.preventDefault();
    handleApplyFilter();
  };

  const handleApplyFilter = (selectedType = typeFilter) => {
    if (!fromDate && !toDate) {
      getRequestHistory(
        "grid",
        search,
        "",
        "",
        statusFilter,
        selectedType
      );
      setFilterModal(false);
      return;
    }

    if (!fromDate || !toDate) {
      toast.error("Please select both From Date and To Date");
      return;
    }

    const from = moment(fromDate, "DD-MM-YYYY", true);
    const to = moment(toDate, "DD-MM-YYYY", true);
    const today = moment().startOf("day");

    if (!from.isValid() || !to.isValid()) {
      toast.error("Please enter valid dates");
      return;
    }

    if (from.isAfter(today)) {
      toast.error("From Date cannot be a future date");
      return;
    }

    if (to.isAfter(today)) {
      toast.error("To Date cannot be a future date");
      return;
    }

    if (to.isBefore(from)) {
      toast.error("To Date cannot be earlier than From Date");
      return;
    }

    if (to.diff(from, "days") > 31) {
      toast.error("Date range should not exceed 1 month");
      return;
    }

    getRequestHistory(
      "grid",
      search,
      fromDate,
      toDate,
      statusFilter,
      selectedType
    );

    setFilterModal(false);
  };

  const handleCloseFilter = () => {
    setTypeFilter("all")
    setFromDate("");
    setToDate("");
    setFilterModal(false);
  };

  // const rowPreviewDetails = async (data) => {
  //   console.log(data, "data928728");

  //   setLoader(true);

  //   try {
  //     const getDetails = await axiosInstance.get(
  //       `${Dealer_Mapping.validationRowPreview}/${data.batchId}`,
  //     );
  //     const decrypted = JSON.parse(
  //       decryptData(getDetails?.data)
  //     );

  //     if (decrypted?.status === 0) {
  //       console.log(decrypted, "rowTables");
  //       setRowData(decrypted?.data)

  //     } else {
  //       toast.error(decrypted?.message);
  //     }
  //   } catch (error) {
  //     console.log(error);

  //   } finally {
  //     setLoader(false);
  //   }
  // };

  // "partial" is the same state as "pending" for the maker, so it is shown as Pending.
  const getStatusClass = (status = "") => {
    switch (normalizeStatus(status)) {
      case "pending":
      case "partial":
        return "status-pending";
      case "approved":
        return "status-approved";
      case "rejected":
        return "status-rejected";
      case "draft":
        return "status-draft";
      case "sendback":
        return "status-sendback";
      default:
        return "";
    }
  };

  const getStatusLabel = (status = "") => {
    const normalized = normalizeStatus(status);
    if (normalized === "partial") return "Pending";
    if (normalized === "sendback") return "Send Back";
    return toSentenceCase(status);
  };

  // Derives the "Category" column value - not a real backend field (the
  // backend never sends reasonType), just a categorization of the free-text
  // "reason" field. The separate "Reason" column shows the backend's
  // "remarks" field, not this "reason" field.
  const getReasonTypeLabel = (data) => {
    const reasonType = data?.reasonType;
    if (reasonType) {
      switch (reasonType.toLowerCase()) {
        case "newmapping":
          return "New Mapping";
        case "updatemapping":
          return "Update existing mapping";
        case "others":
          return "Others";
        default:
          return toSentenceCase(reasonType);
      }
    }

    const reason = data?.reason || "";
    if (reason.toLowerCase() === "new mapping") return "New Mapping";
    if (reason.toLowerCase() === "update existing mapping") return "Update existing mapping";
    if (reason) return "Others";
    return "-";
  };

  const isDownloadDisabled = historyData?.length === 0;
  const totalCount = historyData?.length || 0;
  const paginatedData = historyData
    .slice((page - 1) * limit, page * limit)
    .map((data) => ({
      ...data,
      reason: data?.reason || batchInfo[data?.batchId]?.reason,
      remarks: data?.remarks || batchInfo[data?.batchId]?.remarks,
      // Set only for a bulk batch whose rows carry different reasons.
      reasonTypeLabel: batchInfo[data?.batchId]?.reasonTypeLabel,
    }));

  const visibleBatchKey = historyData
    .slice((page - 1) * limit, page * limit)
    .filter(
      (data) =>
        data?.batchId && !data?.reason && !data?.remarks && !requestedBatches.current.has(data.batchId)
    )
    .map((data) => data.batchId)
    .join(",");

  useEffect(() => {
    if (!visibleBatchKey) return;

    visibleBatchKey.split(",").forEach(async (batchId) => {
      requestedBatches.current.add(batchId);
      try {
        const response = await axiosInstance.get(`${Dealer_Mapping.validationRowPreview}/${batchId}`);
        const decrypted = JSON.parse(decryptData(response?.data));
        if (decrypted?.status === 0) {
          const details = decrypted?.data || {};
          const rows = details?.requests || [];
          // Drafts keep reason / remarks on each row rather than on the batch.
          // Use them only when every row agrees, so a mixed batch never shows
          // one row's value as if it applied to all of them.
          const sharedValue = (field) => {
            const values = [...new Set(rows.map((row) => (row?.[field] || "").trim()))];
            return values.length === 1 ? values[0] : "";
          };
          // The list must show what the maker entered for the whole request,
          // not whatever the individual rows hold, so a bulk batch with mixed
          // rows is not summarised from them.
          // A bulk upload can mix reasons / remarks across its rows. Rather
          // than leave the list blank, every distinct value is listed.
          // const distinctValues = (field) => [
          //   ...new Set(rows.map((row) => (row?.[field] || "").trim()).filter(Boolean)),
          // ];
          const reason = details?.reason || sharedValue("reason");
          const remarks = details?.remarks || sharedValue("remarks");
          // const remarks =
          //   details?.remarks || sharedValue("remarks") || distinctValues("remarks").join("; ");
          // const reasonTypeLabel = reason
          //   ? ""
          //   : [
          //       ...new Set(
          //         distinctValues("reason").map((value) => getReasonTypeLabel({ reason: value }))
          //       ),
          //     ].join(", ");
          // if (reason || remarks || reasonTypeLabel) {
          //   setBatchInfo((prev) => ({
          //     ...prev,
          //     [batchId]: { reason, remarks, reasonTypeLabel },
          //   }));
          // }
          if (reason || remarks) {
            setBatchInfo((prev) => ({ ...prev, [batchId]: { reason, remarks } }));
          }
        }
      } catch (error) {
        // Best-effort - the row just keeps showing "-".
        console.log(error, "batchInfo");
      }
    });
  }, [visibleBatchKey]);
  const totalPages = Math.ceil(totalCount / limit);

  const getPageNumbers = (current, total) => {
    const delta = 1;
    const pages = [];

    for (let i = 1; i <= total; i++) {
      if (i === 1 || i === total || (i >= current - delta && i <= current + delta)) {
        pages.push(i);
      }
    }

    const pagesWithEllipsis = [];
    let previous = null;
    pages.forEach((i) => {
      if (previous !== null && i - previous > 1) {
        pagesWithEllipsis.push("...");
      }
      pagesWithEllipsis.push(i);
      previous = i;
    });

    return pagesWithEllipsis;
  };

  const allTypeRef = useRef(null);

  useEffect(() => {
    if (filterModal) {
      allTypeRef.current?.focus();
    }
  }, [filterModal]);

  const typeRefs = useRef([]);

  const typeOptions = ["all", "single", "bulk"];

  const handleTypeKeyDown = (e, index) => {
    let nextIndex = index;

    switch (e.key) {
      case "ArrowRight":
        e.preventDefault();
        nextIndex = (index + 1) % typeOptions.length;
        setTypeFilter(typeOptions[nextIndex]);
        typeRefs.current[nextIndex]?.focus();
        return;

      case "ArrowLeft":
        e.preventDefault();
        nextIndex =
          (index - 1 + typeOptions.length) % typeOptions.length;
        setTypeFilter(typeOptions[nextIndex]);
        typeRefs.current[nextIndex]?.focus();
        return;

     case "Enter":
    case " ":
      e.preventDefault();
      const selectedType = typeOptions[index];
      setTypeFilter(selectedType);
      handleApplyFilter(selectedType);
      return;

      default:
        return;
    }
  };

  const handleFooterKeyDown = (e) => {
    if (e.key === "ArrowRight") {
      e.preventDefault();
      applyBtnRef.current?.focus();
      return;
    }

    if (e.key === "ArrowLeft") {
      e.preventDefault();
      resetBtnRef.current?.focus();
      return;
    }

    if (e.key === "Enter") {
      e.stopPropagation();
      return;
    }
  };

  const handleHeaderKeyDown = (e, index) => {
  switch (e.key) {
    case "ArrowRight":
      e.preventDefault();
      headerRefs.current[Math.min(index + 1, headerRefs.current.length - 1)]?.focus();
      break;

    case "ArrowLeft":
      e.preventDefault();
      headerRefs.current[Math.max(index - 1, 0)]?.focus();
      break;

    case "Enter":
    case " ":
      e.preventDefault();
      headerRefs.current[index]?.click();
      break;

    default:
      break;
  }
};



  return (
    <>
      <div className="off-market-main">
        <div className="ckr-page new-upload">

          {!isDraftTab && (
            <div className="ckr-queue-wrapper">
              <div className="ckr-stats">
                <div
                  className={`ckr-stat-card status-card ${statusFilter === "all" ? "ckr-stat-active" : ""}`}
                  role="button"
                  tabIndex={0}
                  onClick={() => handleCardFilter("all")}
                  onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); handleCardFilter("all"); } }}
                >
                  <img src={totalReqIcon} alt="" className="ckr-stat-icon-img" />
                  <div className="ckr-stat-info d-flex flex-column">
                    <span className="status-title">Total Requests</span>
                    <span className="ckr-stat-value">{cardCounts.total}</span>
                  </div>
                </div>

                <div
                  className={`ckr-stat-card status-card ${statusFilter === "pending" ? "ckr-stat-active" : ""}`}
                  role="button"
                  tabIndex={0}
                  onClick={() => handleCardFilter("pending")}
                  onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); handleCardFilter("pending"); } }}
                >
                  <img src={pendingIcon} alt="" className="ckr-stat-icon-img" />
                  <div className="ckr-stat-info d-flex flex-column">
                    <span className="status-title">Approval Pending</span>
                    <span className="ckr-stat-value ckr-stat-value--queue">{cardCounts.pending}</span>
                  </div>
                </div>

                <div
                  className={`ckr-stat-card status-card ${statusFilter === "approved" ? "ckr-stat-active" : ""}`}
                  role="button"
                  tabIndex={0}
                  onClick={() => handleCardFilter("approved")}
                  onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); handleCardFilter("approved"); } }}
                >
                  <div className="wrap-app-icon">
                    <img src={approvedIcon} alt="" className="ckr-stat-icon-img" />
                  </div>
                  <div className="ckr-stat-info d-flex flex-column">
                    <span className="status-title">Approved</span>
                    <span className="ckr-stat-value ckr-stat-value--approved">{cardCounts.approved}</span>
                  </div>
                </div>

                <div
                  className={`ckr-stat-card status-card ${statusFilter === "draft" ? "ckr-stat-active" : ""}`}
                  role="button"
                  tabIndex={0}
                  onClick={() => handleCardFilter("draft")}
                  onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); handleCardFilter("draft"); } }}
                >
                  <img src={draftIcon} alt="" className="ckr-stat-icon-img" />
                  <div className="ckr-stat-info d-flex flex-column">
                    <span className="status-title">Draft</span>
                    <span className="ckr-stat-value ckr-stat-value--draft">{cardCounts.draft}</span>
                  </div>
                </div>

                <div
                className={`ckr-stat-card status-card ${statusFilter === "sendback" ? "ckr-stat-active" : ""}`}
                role="button"
                tabIndex={0}
                onClick={() => handleCardFilter("sendback")}
                onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); handleCardFilter("sendback"); } }}
                >
                  <img src={sendBackIcon} alt="" className="ckr-stat-icon-img" />
                  <div className="ckr-stat-info d-flex flex-column">
                    <span className="status-title">Send Back</span>
                    <span className="ckr-stat-value ckr-stat-value--sendback">{cardCounts.sendback}</span>
                  </div>
                </div>

                <div
                  className={`ckr-stat-card status-card ${statusFilter === "rejected" ? "ckr-stat-active" : ""}`}
                  role="button"
                  tabIndex={0}
                  onClick={() => handleCardFilter("rejected")}
                  onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); handleCardFilter("rejected"); } }}
                >
                  <img src={rejectedIcon} alt="" className="ckr-stat-icon-img" />
                  <div className="ckr-stat-info d-flex flex-column">
                    <span className="status-title">Rejected</span>
                    <span className="ckr-stat-value ckr-stat-value--rejected">{cardCounts.rejected}</span>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="ckr-section history-table">
            <div className="ckr-section-header">
              <p className="ckr-section-title">Request History</p>

              <div className="d-flex align-items-center header-filter">

                {!isDraftTab && (
                  <div className="filter-options offmark-filter">
                    <div className="dropdown-filter focusable-filter">
                      <select
                        size="lg"
                        aria-label="Default select example"
                        value={statusFilter}
                        onChange={(e) => {
                          const value = e.target.value;
                          setStatusFilter(value);
                          getRequestHistory(
                            "grid",
                            search,
                            fromDate,
                            toDate,
                            value,
                            typeFilter
                          );
                        }}
                      >
                        <option value="all">All</option>
                        <option value="approved">Approved</option>
                        <option value="pending">Pending</option>
                        <option value="rejected">Rejected</option>
                        <option value="draft">Draft</option>
                        <option value="sendback">Send Back</option>

                      </select>
                    </div>
                  </div>
                )}

                <div className="filter-wrapper focusable-filter" 
                tabIndex={0} 
                ref={(el) => (headerRefs.current[1] = el)}
                role="button"
                onClick={showFilterModal}
                onKeyDown={(e) => handleHeaderKeyDown(e, 1)}>
                  <img src={filter} alt="filter" />
                </div>

                <div className="ckr-search-box focusable-filter">
                  <i className="fa fa-search" />
                  <input
                    ref={(el) => (headerRefs.current[2] = el)}
                    onKeyDown={(e) => handleHeaderKeyDown(e, 2)}
                    type="text"
                    placeholder="Search by SR"
                    value={search}
                    maxLength={10}
                    onChange={(e) => setSearch(batchIdFormatter(e?.target?.value))}
                    onPaste={() => batchIdPaste(10)}
                  />
                </div>

                <div className={`wrap-down-btn focusable-filter ${isDownloadDisabled ? "disabled-btn-download" : ""}`}
                 role="button"
                  tabIndex={isDownloadDisabled ? -1 : 0}
                  onClick={() => {
                    if (isDownloadDisabled) return;

                    getRequestHistory(
                      "file",
                      search,
                      fromDate,
                      toDate,
                      statusFilter,
                      typeFilter
                    )
                  }}
                  ref={(el) => (headerRefs.current[3] = el)}
                  onKeyDown={(e) => handleHeaderKeyDown(e, 3)}>
                  {downloadLoader ?
                    <SmallLoader />
                    :
                    <>
                      <img src={downIcon} alt="download-icon" />
                      <button
                        type="button"
                        className={`download-template ${isDownloadDisabled ? "disabled-text" : ""}`}
                        disabled={isDownloadDisabled}>Download</button>
                    </>
                  }
                </div>

              </div>
            </div>
            <div className="ckr-table-wrapper cdm-table">
              {loader ?
                <div className="loader-alignment">
                  <Loader />
                </div>
                :
                historyData?.length > 0 ?
                  <>
                  <table className="ckr-table draft-maker dm-fixed-cols">
                    <thead>
                      <tr>
                        <th className="dm-col-sr">SR</th>
                        <th className="dm-col-date">Request Date</th>
                        <th className="dm-col-count">Total Count</th>
                        <th className="dm-col-reason-type">Reason Type</th>
                        <th className="dm-col-reason">Reason</th>
                        <th className="dm-col-status">Status</th>
                        <th className="dm-col-action">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {paginatedData.map((data) => (
                        <tr key={data.batchId}>
                          <td>{data?.batchId || "-"}</td>
                          <td>{formatDate(data.requestDate) || "-"}</td>
                          <td>{data.count || 0}</td>
                          {/* <td>{getReasonTypeLabel(data)}</td> */}
                          <td>{data?.reasonTypeLabel || getReasonTypeLabel(data)}</td>
                          {/* This "Reason" column shows the backend's "remarks" field, not
                              the backend's "reason" field (that's categorized into the
                              "Category" column above via getReasonTypeLabel). */}
                          {/* <td>{data?.remarks || "-"}</td> */}
                          {/* <td className="dm-col-reason">
                            {data?.remarks ? (
                              <OverlayTrigger placement="top" overlay={<Tooltip id={`remarks-tooltip-${data.id}`} className="dm-reason-tooltip">{data.remarks}</Tooltip>}>
                                <span className="dm-reason-text">{data.remarks}</span>
                              </OverlayTrigger>
                            ) : "-"}
                          </td> */}
                          <td className="dm-col-reason">
                            <span className="dm-reason-text">{data?.remarks || "-"}</span>
                          </td>
                          <td className="dm-col-status">
                            {data?.status !== "" ?
                              <span className={getStatusClass(data?.status)}>
                                {getStatusLabel(data?.status)}
                              </span>
                              : "-"}
                          </td>
                          <td>
                            <div className="view-btn">
                              <button
                                className={`submit-btns-view`}
                                onClick={() => handleViewButton(data)}
                              >
                                View Details
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>

                  <div className="d-flex align-items-center justify-content-between pagination-wrapper">
                    <div className="pagination-left d-flex align-items-center">
                      <span className="items-label">Items per page</span>

                      <select
                        value={limit}
                        onChange={(e) => {
                          setLimit(Number(e.target.value));
                          setPage(1);
                        }}
                        className="page-select"
                      >
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                      </select>

                      <span className="page-count">
                        {totalCount === 0
                          ? "0-0 items"
                          : `${(page - 1) * limit + 1}-${Math.min(page * limit, totalCount)} of ${totalCount} items`}
                      </span>
                    </div>

                    <div className="pagination-right d-flex align-items-center">
                      <button
                        className="pagination-btn"
                        disabled={page === 1}
                        onClick={() => setPage((prev) => prev - 1)}
                      >
                        &lt;
                      </button>

                      {getPageNumbers(page, totalPages).map((item, index) =>
                        item === "..." ? (
                          <span key={`dots-${index}`} className="pagination-dots">
                            ...
                          </span>
                        ) : (
                          <button
                            key={item}
                            className={`pagination-number ${page === item ? "active-page" : ""}`}
                            onClick={() => setPage(item)}
                          >
                            {item}
                          </button>
                        )
                      )}

                      <button
                        className="pagination-btn"
                        disabled={page === totalPages}
                        onClick={() => setPage((prev) => prev + 1)}
                      >
                        &gt;
                      </button>
                    </div>
                  </div>
                  </>
                  :
                  <div className="step-content report-error-message">
                    {noDataFound()}
                  </div>
              }
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={filterModal}
        onHide={() => setFilterModal(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="inactive-modal setting-model cdm-date-modal"
        backdrop="static"
        keyboard={true}
      >
        <Modal.Header className="mb-4 modal-header">
          <Modal.Title id="contained-modal-title-vcenter modal-title">
            <div className="figure-inlac header-pnl">
              <span className="header-title">Filters</span>
            </div>
          </Modal.Title>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={handleCloseFilter}
          >
            <span className="icon-close"></span>
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="table-responsive scroll-table model-top-active-table"
            onKeyDown={handleFilterKeyDown}>
            <span className="body-title-main">Select Type</span>
            <div className="type-wrapper"
              role="radiogroup"
              aria-label="Select Type">

              <button
                ref={allTypeRef}
                role="radio"
                type="button"
                aria-checked={typeFilter === "all"}
                className={`type-button ${typeFilter === "all" ? "active" : ""}`}
                onClick={() => setTypeFilter("all")}
                onKeyDown={(e) => handleTypeKeyDown(e, 0)}
              >
                All Type
              </button>

              <button
                ref={(el) => (typeRefs.current[1] = el)}
                role="radio"
                type="button"
                aria-checked={typeFilter === "single"}
                className={`type-button ${typeFilter === "single" ? "active" : ""}`}
                onClick={() => setTypeFilter("single")}
                onKeyDown={(e) => handleTypeKeyDown(e, 1)}
              >
                Single
              </button>

              <button
                ref={(el) => (typeRefs.current[2] = el)}
                role="radio"
                type="button"
                aria-checked={typeFilter === "bulk"}
                className={`type-button ${typeFilter === "bulk" ? "active" : ""}`}
                onClick={() => setTypeFilter("bulk")}
                onKeyDown={(e) => handleTypeKeyDown(e, 2)}
              >
                Bulk
              </button>
            </div>
            <span className="body-title-main">Custom Date Range</span>

            <div className="date-wrapper">
              <div className="form-group">
                <label htmlFor="" className="form-label">
                  From Date<span className="manadate-mark">*</span>

                </label>
                <div>
                  <CustomTradeDate
                    idPrefix="fromDate"
                    value={fromDate}
                    onChange={(date) => {
                      setFromDate(date);
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        handleApplyFilter();
                      }
                    }}
                    maxDate={toDate || DateReverse}
                  />
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="" className="form-label">
                  To Date<span className="manadate-mark">*</span>
                </label>
                <div>
                  <CustomTradeDate
                    idPrefix="toDate"
                    value={toDate}
                    onChange={(date) => {
                      setToDate(date);
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        handleApplyFilter();
                      }
                    }}
                    minDate={fromDate}
                    maxDate={DateReverse}
                  />
                </div>
              </div>
            </div>

            <div className="info-banner">
              <img src={infoIcon} alt="info icon" />
              <span className="banner-text">Please select a date range where difference between From date and To date is less than 1 month</span>
            </div>

            <div className="footer-actions modal-footer">
              <button type="button"
                ref={resetBtnRef}
                className="back-btn"
                onClick={handleResetFilter}
                onKeyDown={handleFooterKeyDown}
              >Reset</button>
              <button type="button"
                ref={applyBtnRef}
                className="submit-btns"
                onClick={() => handleApplyFilter()}
                onKeyDown={handleFooterKeyDown}
              >
                Apply
              </button>
            </div>

          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default MyRequests;

